import React, { useState, useEffect, useRef } from "react";
import {
  CancelIconBlack,
  left_arrow,
  right_arrow,
  search_svg,
} from "../../../constant/imagePath";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import { ReactSVG } from "react-svg";
import classes from "./SearchResults.module.css";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import { Col, Container, Row } from "react-bootstrap";
import { MobileFilter } from "../../../stories/MobileFilter/MobileFilter.jsx";
import { CoachDetailCard } from "../../../stories/CoachDetailCard/CoachDetailCard.jsx";
import { Button } from "../../../stories/Button/Button";
import Carousel from "react-elastic-carousel";
import moment from "moment";
import PopoverTrigger from "../../../stories/PopoverTrigger/PopoverTrigger";
import Maps from "../../../components/Maps";
import SearchResultModal from "../../../components/Modals/StudentFlow/SearchResultsModal/SearchResultsModal";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import SearchResultsMobile from "./SearchResultsMobile";
// import right_arrow from "../../assets/images/right_arrow_date.png";
// import left_arrow from "../../assets/images/left_arrow_date.png";

// Find More Coaches

function FindMoreCoaches() {
  return (
    <div className={classes.findMoreCoaches}>
      <h4 style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}>
        Find more coaches
      </h4>
      <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
        Try adjusting your search filters to see available coaches
      </p>
      <Button
        label={"Clear filters"}
        primary={false}
        size={"Medium"}
        customStyle={{ padding: "14px 37px", width: "max-content" }}
      />
    </div>
  );
}

const SearchResultsDesktop = (props) => {
  const [customClass, setCustomClass] = useState("");
  const [counter, setCounter] = useState(0);
  const [filterClick, setFilterClick] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [btnText, setBtnText] = useState(null);
  //save Filter State
  const [showModal, setShowModal] = useState(false);

  //range state
  const [minAndMaxPrice, setMinAndMaxPrice] = useState([0, 100]);
  const [value, setValue] = useState([0]);
  const [checkBoxTitle, setCheckBoxTitle] = useState([]);
  const [radioBtnData, setRadioBtnData] = useState(["Gender"]);
  const [priceRangeShower, setPriceRangeShower] = useState([]);
  const [distanceShower, setDistanceShower] = useState([]);
  const [showCancelIcon, setShowCancelIcon] = useState(false);

  // Map Popup
  const [showPopup, setShowPopup] = useState(false);

  const [data, setData] = useState([1]);
  const ref = useRef();

  console.log(showCancelIcon, "showIcon------------");
  const onClickSearch = (data) => {
    setCustomClass(data);
  };
  console.log(btnText);
  const handleSearch = (data) => {
    console.log(data);
  };
  const handlePriceRange = () => {
    setPriceRangeShower(minAndMaxPrice);
    setAnchorEl(null);
    setShowCancelIcon(true);
  };

  const handleDistanceRange = () => {
    setDistanceShower(value);
    setAnchorEl(null);
    setShowCancelIcon(true);
  };
  const onSaveHandler = () => {
    setRadioBtnData(checkBoxTitle);
    setAnchorEl(null);
    setShowCancelIcon(true);
  };

  const handleClickClear = () => {
    setPriceRangeShower([]);
    setDistanceShower([]);
    setRadioBtnData(["Gender"]);
    setShowCancelIcon(false);
  };

  const handleClickSaveFilter = () => {
    setShowModal(true);
  };

  console.log(showModal, "showModal");
  const dummy = [
    "My filters",
    `Focus tags `,
    `Price range ${priceRangeShower.length != 0
      ? `$${priceRangeShower[0]}-$${priceRangeShower[1]}`
      : ""
    }`,
    `Distance ${distanceShower.length !== 0 ? distanceShower : ""}`,
    "Schedule",
    radioBtnData[0],
    "Specialties",
  ];
  const options = [
    { label: "any", count: "(4,760)" },
    { label: "female", count: "(1938)" },
    { label: "male", count: "(1839)" },
    { label: "others", count: "(983)" },
  ];

  const Specialties = [
    {
      title: "Skill Levelss",
      childOptions: [
        { label: "Beginner", count: "(12)" },
        { label: "Intermediate", count: "(72)" },
        { label: "Competitive", count: "(72)" },
        { label: "Advanced", count: "(72)" },
      ],
    },
    // {
    //   title: "Age range",
    //   childOptions: [
    //     { label: "Kids", count: "(12)" },
    //     { label: "Juniors", count: "(72)" },
    //   ],
    // },
  ];

  const month = moment().add(counter, "day").format("ddd");

  const dateRender = moment().add(counter, "day").format("DD MMM");

  const month1 = moment()
    .add(counter + 1, "day")
    .format("ddd");
  const dateRender1 = moment()
    .add(counter + 1, "day")
    .format("DD-MMM");
  const month2 = moment()
    .add(counter + 2, "day")
    .format("ddd");
  const dateRender2 = moment()
    .add(counter + 2, "day")
    .format("DD-MMM");
  const month3 = moment()
    .add(counter + 3, "day")
    .format("ddd");
  const dateRender3 = moment()
    .add(counter + 3, "day")
    .format("DD-MMM");

  const dateData = [
    {
      day: month,
      month: dateRender,
    },
    {
      day: month1,
      month: dateRender1,
    },
    {
      day: month2,
      month: dateRender2,
    },
    {
      day: month3,
      month: dateRender3,
    },
  ];

  const locationData = [
    {
      id: 1,
      location: {
        lat: 32.715736,
        lng: -117.161087,
      },
    },
    {
      id: 2,
      location: { lat: 32.672661, lng: -117.109377 },
    },
    {
      id: 3,
      location: { lat: 32.737109, lng: -117.131561 },
    },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setBtnText(event.target.innerText);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
      <style>
        {`
  .date_slider_cus .rec .rec-carousel-item{
display:flex;
align-items:center;
  }

@media (max-width:1250px){
  .parent_div .dnone_b {
    display:none
  }
  .parent_div .cus_div_b{
    width:100%
  }
}





  `}
      </style>
      <AfterLoginHeader
        onClickSearch={onClickSearch}
        showSearch={true}
        onSubmitSearch={handleSearch}
        className={classes.header}
        customStyle={{
          borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
        }}
      />

      {/* Div For Search OverLay Start */}
      <div className={`${customClass}`}></div>
      {/* Div For Search OverLay End */}
      <Container fluid className={classes.conti_card}>
        <Row className={classes.row}>
          <Col className={classes.cus_width_9} md={9}>
            <div className={classes.mt24}>
              <MobileFilter
                handleClick={handleClick}
                setter={setFilterClick}
                state={filterClick}
                filters={dummy}
                handleClickClear={handleClickClear}
                showCancelIcon={showCancelIcon}
                handleClickSaveFilter={handleClickSaveFilter}
                isScroll={false}
              />
              <PopoverTrigger
                handlePriceRange={handlePriceRange}
                options={options}
                minAndMaxPrice={minAndMaxPrice}
                setMinAndMaxPrice={setMinAndMaxPrice}
                btnText={btnText}
                open={open}
                handleClose={handleClose}
                anchorEl={anchorEl}
                value={value}
                setValue={setValue}
                setRadioBtnData={setRadioBtnData}
                radioBtnData={radioBtnData}
                checkBoxTitle={checkBoxTitle}
                setCheckBoxTitle={setCheckBoxTitle}
                Specialties={Specialties}
                handleDistanceRange={handleDistanceRange}
                onSaveHandler={onSaveHandler}
              />
              {/* <img src={CancelIconBlack} /> */}
            </div>

            {data == null ? (
              <div className={classes.parent}>
                <div className={classes.noResultMain}>
                  <ReactSVG src={search_svg} className={classes.search_svg} />
                  <p
                    style={{
                      ...Fonts.h4,
                      color: Colors.neutralShadesOfNero,
                      fontSize: "26px",
                      lineHeight: "36px",
                      marginBottom: "20px",
                    }}
                    className={[classes.mb28].join(" ")}
                  >
                    No results
                  </p>
                  <p
                    className={classes.p_text}
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    Try adjusting your search filters to see available coaches
                  </p>

                  <Button
                    label={"Clear Filters"}
                    primary={true}
                    customStyle={{
                      width: "200px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                      margin: "19px auto",
                    }}
                  />
                </div>
              </div>
            ) : (
              <>
                <Row className={`g-0 ${classes.date_slider_row}`}>
                  <Col>
                    {" "}
                    <h4>251 results</h4>
                  </Col>
                  <div className={classes.date_slider_col1}>
                    <button
                      onClick={() => {
                        ref.current.slidePrev();
                        setCounter((prev) => prev - 1);
                      }}
                    >
                      <img src={left_arrow} />
                    </button>
                    <Carousel
                      className={`date_slider_cus ${classes.date_slider_day}`}
                      pagination={false}
                      showArrows={false}
                      itemPadding={[0, 2, 2, 2]}
                      itemsToShow={4}
                      ref={ref}
                    >
                      {dateData.map((item) => {
                        return (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                              }}
                            >
                              <div style={{ ...Fonts.p3 }}>{item?.day}</div>
                              <div
                                style={{
                                  fontWeight: "600",
                                  ...Fonts.h9,
                                  lineHeight: "20px",
                                }}
                              >
                                {item?.month}
                              </div>
                            </div>
                          </>
                        );
                      })}

                      {/* <div style={{ textAlign: "center" }}>
                        <div>{month}</div>
                        <div style={{ fontWeight: "600" }}>{dateRender}</div>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <div>{month1}</div>
                        <div style={{ fontWeight: "600" }}>{dateRender1}</div>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <div>{month2}</div>
                        <div style={{ fontWeight: "600" }}>{dateRender2}</div>
                      </div> */}
                    </Carousel>
                    <button
                      onClick={() => {
                        ref.current.slideNext();
                        setCounter((prev) => prev + 1);
                      }}
                    >
                      <img src={right_arrow} />
                    </button>
                  </div>
                </Row>
                <div className="parent_div">
                  <CoachDetailCard width_B={"111px"} />
                  <FindMoreCoaches />
                </div>
              </>
            )}
          </Col>
          <Col className={classes.cus_width_3} md={3}>
            <Maps type="map" data={locationData} />
          </Col>
        </Row>
      </Container>

      {showModal && (
        <SearchResultModal show={showModal} setShow={setShowModal} />
      )}
    </>
  );
};

const SearchResults = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <SearchResultsMobile /> : <SearchResultsDesktop />;
};

export default SearchResults;
